import { useQuery } from "@tanstack/react-query";
import { Space } from "antd";
import { Link } from "react-router-dom";
import { fetchReplacementTransportOptions } from "../../../../lib/api/resources/replacementTransports";
import { replacementTransportOptionColumns } from "./lib/constants/replacementTransportOptionColumns";
import { Table } from "@/components/v2";
import { Button } from "@rumbledirect/ui";
import { PlusOutlined } from "@ant-design/icons";

export const ReplacementTransportOptionsList = () => {
  const replacementTransportOptionsQuery = useQuery({
    queryKey: ["replacementTransportOptions"],
    queryFn: fetchReplacementTransportOptions,
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/replacement-transport/options/create">
          <Button icon={<PlusOutlined />}>
            Nieuwe vervangend vervoer optie
          </Button>
        </Link>
      </Space>
      <Table
        columns={replacementTransportOptionColumns}
        dataSource={replacementTransportOptionsQuery.data?.member}
        loading={replacementTransportOptionsQuery.isLoading}
        pagination={false}
      />
    </div>
  );
};
